// utils/audiences.js
export const AUDIENCES = [
  { key: "male", label: "Male" },
  { key: "female", label: "Female" },
  { key: "coed", label: "Coed" },
];
